import React from 'react';
import introduce from '../db/introduce.json';


function Introduce(props) {

    let typo_bg = '';
    for(let i = 0;i < 20; i++){
        typo_bg += '안종현 개인포트폴리오 프로젝트 ';
    }

    const skill = introduce.skills.map((e)=>{
        return e + ', ';
    })
    
    return (
        <>
            <section id="introduce" className="relative">
                <div className="wrap relative z-10 flex flex-wrap text-white relative">
                    <article className="w-7/12 sticky top-12 h-36">
                        <h3 className="text-5xl pb-4 w-full">INTRODUCE</h3>
                        <p className="text-xl">
                            전직 웹디자이너.
                            <br />
                            웹에 관심이 많은
                            <br />
                            아저씨입니다.
                        </p>
                    </article>
                    <article className="w-5/12 relative after:content-[''] after:w-px after:bg-white after:absolute after:start-0">
                        <ul className='[&>*:not(:first-child)]:pt-6'>
                            {introduce.history.map(list => (
                                <li className="pb-6 border-b pl-7" key={list.title}>
                                    <h4 className="text-3xl pb-2">{list.duration}</h4>
                                    <p className="font-extralight pb-2">
                                        <span className="font-bold">{list.title}</span>
                                        <br />
                                        {list.summary}
                                    </p>
                                    <div className="flex flex-wrap gap-1" style={props.fontSize}>
                                        {list.tag.map(list2 => (
                                            <span className="font-extralight bg-white text-black px-1.5 rounded-xl" key={list2}>#{list2}</span>
                                        ))}
                                    </div>
                                </li>
                            ))}
                            <li className="pl-7">
                                <h4 className="text-3xl pb-4">SKILL</h4>
                                <p className="font-bold uppercase">
                                    {skill}
                                </p>
                            </li>
                        </ul>
                    </article>
                </div>
                <div className="absolute inset-0 text-justify leading-tight bg-white overflow-hidden text-7xl">{typo_bg}</div>
            </section>
        </>
    );
}

export default Introduce;